import { createTheme } from '@mui/material/styles';
import { colors } from './colors.js';

var shippoTheme = createTheme({
    typography: {
        fontFamily: [
            '"neue-haas-unica"',
            '"pragmatica-web"',
            '"Helvetica Neue"',
            'Helvetica',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    breakpoints: {
        values: {
            xs: 0,
            // xs: 0 - 599 (Mobile)
            sm: 600,
            // sm: 600 - 847 (Small Tablet)
            md: 848,
            // md: 848 - 991 (Large Tablet)
            lg: 992,
            // lg: 992 - 1339 (Desktop)
            xl: 1440,
            //  xl: 1440+ (Large Desktop)
        },
    },
    palette: {
        primary: {
            main: colors.primary,
        },
        secondary: {
            main: colors.secondary,
        },
        error: {
            main: colors.accent.foreground.error,
        },
        warning: {
            main: colors.accent.foreground.warning,
        },
        info: {
            main: colors.accent.foreground.informational,
        },
        success: {
            main: colors.accent.foreground.success,
        },
    },
    components: {
        MuiList: {
            styleOverrides: {
                root: {
                    '&.MuiList-root': {
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                },
            },
        },
    },
});

export { shippoTheme as default };
//# sourceMappingURL=shippoTheme.js.map
